var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineBlueHoriz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1289,
    height: 1,
    viewBox: "0 0 1289 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1289,
    height: 1,
    rx: 0.5,
    fill: "#82AEDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBlueHoriz);
export default __webpack_public_path__ + "static/media/LineBlueHoriz.3eacbdcf45aa3f0c0caf2535b1ebb7cd.svg";
export { ForwardRef as ReactComponent };